import Modal from '../custom/Modal';
import ModalClose from './ModalClose';
import { useAppTranslation } from '../../i18n';
import { useDispatch } from 'react-redux';
import { ModalEnum, uiActions } from '../../app/slices/ui.slice';
import ImprintModalCustomization from '../customizations/ImprintModalCustomization';

const ImpressumModal = () => {
	const dispatch = useDispatch();
	const { t } = useAppTranslation();

	const handleOnCloseModal = () => {
		dispatch(uiActions.toggleModal(ModalEnum.IMPRESSIUM_MODAL));
	};

	return (
		<Modal onClose={handleOnCloseModal} ariaLabel={t('footer.impressum')}>
			<ModalClose onClose={handleOnCloseModal} />
			<ImprintModalCustomization />
		</Modal>
	);
};

export default ImpressumModal;
